import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tabButton", "tabContent"]
  static values = { defaultTab: String }

  connect() {
    // Initialize with the default tab
    this.selectTab({ currentTarget: { dataset: { tab: this.defaultTabValue || "cast-crew" } } })
  }

  selectTab(event) {
    const selectedTab = event.currentTarget.dataset.tab

    // Update tab buttons
    this.tabButtonTargets.forEach(button => {
      const tab = button.dataset.tab
      const isSelected = tab === selectedTab
      
      // Update aria-selected
      button.setAttribute("aria-selected", isSelected)
      
      // Update visual styles
      if (isSelected) {
        button.classList.remove("text-slate-400", "border-transparent", "hover:text-slate-300")
        button.classList.add("text-amber-50", "border-amber-500")
      } else {
        button.classList.remove("text-amber-50", "border-amber-500")
        button.classList.add("text-slate-400", "border-transparent", "hover:text-slate-300")
      }
    })

    // Update tab content
    this.tabContentTargets.forEach(content => {
      const tab = content.dataset.tab
      const isSelected = tab === selectedTab
      
      if (isSelected) {
        content.classList.remove("hidden")
        content.setAttribute("aria-hidden", "false")
      } else {
        content.classList.add("hidden")
        content.setAttribute("aria-hidden", "true")
      }
    })
  }
}